import { Select } from "antd";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useTranslation } from "react-i18next";
import { selectClientCountryCode, setClientCountryCode } from "store/language";

import { SelectLanguageStyle } from "./SelectLanguageStyle";

const languageOptions = [{ value: "en", label: "EN" }];

export const SelectLanguage = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const clientCountryCode = useAppSelector(selectClientCountryCode);

  const handleChangeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    dispatch(setClientCountryCode(language));
  };

  return (
    <SelectLanguageStyle>
      <Select
        options={languageOptions}
        value={languageOptions.find(
          (language) => language.value === clientCountryCode
        )}
        onChange={(_, option) => {
          handleChangeLanguage(
            (
              option as {
                value: string;
                label: string;
              }
            ).value
          );
        }}
      />
    </SelectLanguageStyle>
  );
};
